import React from 'react';
import { Link } from 'react-router-dom';
import SubNav from '../components/subNav';
import SEO from '../components/SEO';
import { baseUrl } from '../config';



const Prime = () => {
  const distributors = [
    { name: 'John Doe', designation: 'Distribution Manager', price: '$5,000' },
    { name: 'Jane Smith', designation: 'Content Strategist', price: '$7,500' },
    { name: 'Mark Johnson', designation: 'Film Distributor', price: '$10,000' },
    // Add more distributors as needed
  ];

  return (
    <>
    <SEO
      title="Amazon Prime Film Distribution"
      description="Submit your film for distribution on Amazon Prime Video through ProducerBuddy's integrated distribution workflow."
      url="https://producerbuddy.pilomation.com/prime"
      robots="noindex, nofollow"
    />
    <SubNav/>
    <div className='bg-gray-900 text-white min-h-screen p-5'>
      <div className="max-w-7xl mx-auto">
        <h2 className='font-extrabold text-4xl text-center p-4 text-yellow-400' style={{fontSize:'16px'}}>
          Amazon Prime Distribution Partners
        </h2>
        <p className='text-center text-lg p-4 max-w-3xl mx-auto text-gray-300'>
          Here is a list of distribution partners for Netflix. Connect with them to get your movie distributed.
        </p>

        {/* Table to show distribution partners */}
        <table className="table-auto w-full text-gray-300 mt-6">
          <thead>
            <tr>
              <th className="px-4 py-2 text-left">Name</th>
              <th className="px-4 py-2 text-left">Designation</th>
              <th className="px-4 py-2 text-left">Price for Distribution</th>
              <th className="px-4 py-2 text-left">Action</th>
            </tr>
          </thead>
          <tbody>
            {distributors.map((distributor, index) => (
              <tr key={index} className="border-t border-gray-700">
                <td className="px-4 py-3">{distributor.name}</td>
                <td className="px-4 py-3">{distributor.designation}</td>
                <td className="px-4 py-3">{distributor.price}</td>
                <td className="px-4 py-3">
                  <Link to='/connect'>
                    <button className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-semibold px-4 py-2 rounded-lg">
                      Connect
                    </button>
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Back to Distributions */}
        <div className='mt-4 text-center py-6'>
          <Link to='/distributions' className='bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-semibold px-6 py-3 rounded-lg shadow-lg'>
            Back to Distributions
          </Link>
        </div>
      </div>
    </div>
    </>
  );
}

export default Prime;

